import AccordionItem from 'components/v2/common/AccordionItem';
import DataSourceDetails from './DataSourceDetails';
import DataSourceSummary from './DataSourceSummary';

export default function DataSource({handle, trendsHandle, mode, label}) {
    return (
        <AccordionItem
                key={handle.id}
                summaryComponent={<DataSourceSummary handle={handle} label={label} />}>
            <DataSourceDetails handle={handle} trendsHandle={trendsHandle} mode={mode} label={label} />
        </AccordionItem>
    );
}
